import React from 'react';
import {withNamespaces} from 'react-i18next';
import styled from 'styled-components';

const StyledCopyright = styled.div`
  font-size: 12px;
  text-align: center;
`;

const Copyright = ({t}) => {
  return (
    <StyledCopyright>
      <p>Copyright © 2017 Hauser & Wirth.</p>
      <p>{t('copyright.rights')}</p>
    </StyledCopyright>
  );
};

export default withNamespaces()(Copyright);



// WEBPACK FOOTER //
// ./src/components/Copyright.js